export default __webpack_public_path__ + "static/media/Desert 1.d00fb2f7.png";